import * as React from 'react';
import logo from '../assets/nl_logo.svg';
import cone from '../assets/cone.svg';
import { useIntl } from 'react-intl';
import {
  ErrorMessage,
  getDeviceId,
  getNovadeUrl,
  trackGotoNovadeLiteEvent,
} from '../utils/utils';
import { Card, Button } from '@mui/material';
import background from '../assets/nl_skyline.svg';
import { useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Profile } from '../components/types';

export const Error = () => {
  const intl = useIntl();
  const params = useLocation();
  const state =
    (params.state as { profile?: Profile; errorMessage?: ErrorMessage }) ?? {};
  const { profile, errorMessage } = state;
  const { titleID, subtitleID } = errorMessage ?? {};

  const handleGoToNovadeLite = () => {
    const deviceIDParams = getDeviceId(profile);
    trackGotoNovadeLiteEvent(profile);
    const novadeUrl = getNovadeUrl();
    const path = isMobile ? '/splash' : '/';
    if (isMobile) {
      window.open(`${novadeUrl}${path}${deviceIDParams}`);
    }

    window.location.replace(`${novadeUrl}${path}${deviceIDParams}`);
  };

  const backgroundStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'repeat-x',
    backgroundPosition: 'bottom',
    backgroundAttachment: 'fixed',
  };

  return (
    <div className="App" style={backgroundStyle}>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: isMobile ? 'flex-start' : 'flex-end',
          marginTop: '24px',
        }}
      >
        <img src={logo} alt="logo" />
      </div>
      <div
        style={{
          width: isMobile ? '100%' : '378px',
          flex: 1,
          padding: '16px 16px',
        }}
      >
        <div>
          <img
            src={cone}
            alt="cone"
            style={{
              marginTop: '16px',
              marginBottom: '16px',
            }}
          />
        </div>
        {titleID && (
          <div
            className="titleLarge"
            style={{
              marginBottom: '8px',
            }}
          >
            {intl.formatMessage({
              id: titleID,
            })}
          </div>
        )}
        {subtitleID && (
          <div
            className="bodyMedium"
            style={{
              marginBottom: '24px',
            }}
          >
            {intl.formatMessage({ id: subtitleID })}
          </div>
        )}
        <Card elevation={0}>
          <div>
            <Button
              fullWidth
              disableElevation
              variant="contained"
              sx={{
                textTransform: 'capitalize',
                '&.Mui-disabled': {
                  background: '#2864AC',
                },
              }}
              onClick={handleGoToNovadeLite}
            >
              {intl.formatMessage({
                id: 'go_to_novade',
              })}
            </Button>
          </div>
        </Card>
      </div>
      <div
        style={{
          flex: 1,
        }}
      ></div>
    </div>
  );
};
